import { Component, HostBinding, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-fieldset-toggle",
    templateUrl: "./fieldset-toggle.component.html",
    styleUrls: ["./fieldset-toggle.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class FieldsetToggleComponent {
  @Input() label: string;
  @Input() nrOfSelectedFilters: number;

  @Input() openWidth = "100%";
  @Input() closedWidth = "50%";

  @Input()
  set defaultExpanded(val: boolean) {
      this.expanded = val;
      this.setWidth();
  }

  @HostBinding("style.width") width = this.closedWidth;
  expanded = false;

  toggle(): void {
      this.expanded = !this.expanded;
      this.setWidth();
  }

  private setWidth() {
      this.width = this.expanded ? this.openWidth : this.closedWidth;
  }
}
